export default __webpack_public_path__ + "static/media/close_question.26e65bc3.svg";